module.exports = __webpack_public_path__ + "media/stylesheets/images/trash-cf204ea0eecf6a670df6512f8de8a596.svg";